import { FieldType } from "../api.js";
import { PlaySpinTxModelConvertSpec } from "./play-spin.specs.js";
import { PlaySpinRewardType } from "./wallet.js";
import { BaseModelConvertSpec } from "./base.specs.js";
import { WalletTxMethod } from "./account.js";
const WalletModelConvertSpec = {
  ...BaseModelConvertSpec,
  balance: FieldType.BigNumber
};
const buildRewardTypesSpec = () => {
  return Object.values(PlaySpinRewardType).reduce(
    (acc, rewardType) => {
      acc[rewardType] = {
        maxCredit: FieldType.BigNumber,
        minCredit: FieldType.BigNumber
      };
      return acc;
    },
    {}
  );
};
const WalletStatusSpecs = {
  balance: FieldType.Number,
  lastClaimedAt: FieldType.DateTime,
  currentPeriodResetDate: FieldType.DateTime,
  nextPeriodResetDate: FieldType.DateTime
};
const MegaShareTxModelConvertSpec = {
  ...BaseModelConvertSpec,
  amount: FieldType.BigNumber,
  unlockedAt: FieldType.DateTime,
  sharedAt: FieldType.DateTime,
  friendClaimedAt: FieldType.DateTime,
  completedAt: FieldType.DateTime,
  expiredAt: FieldType.DateTime
};
const RewardsStatusSpecs = {
  [WalletTxMethod.PlaySpin]: {
    rewardTypes: buildRewardTypesSpec(),
    lastPlaySpinTx: PlaySpinTxModelConvertSpec
  },
  [WalletTxMethod.MegaShare]: {
    megaShareTx: MegaShareTxModelConvertSpec,
    sharedMegaShareTx: MegaShareTxModelConvertSpec,
    earningSettings: {
      expiryHours: FieldType.Number,
      expiredDurationHours: FieldType.Number,
      cooldownHours: FieldType.Number
    }
  }
};
export {
  MegaShareTxModelConvertSpec,
  RewardsStatusSpecs,
  WalletModelConvertSpec,
  WalletStatusSpecs
};
